module.exports = {
    apiKey: "AIzaSyCiraHRW2-K_DrziKSnF0zY5O8kB2LxZq8",
    authDomain: "balus-stage.firebaseapp.com",
    databaseURL: "https://balus-stage.firebaseio.com",
    projectId: "balus-stage",
    storageBucket: "balus-stage.appspot.com",
    messagingSenderId: "48429250518"
};



// WEBPACK FOOTER //
// ../etc/config/firebase/staging.js